import React, { useEffect } from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import './components.css';
import { Button } from '@mui/material';
import { useTranslation } from "react-i18next";

const EmailMatchDialog = ({ isOpen, onClose}) => {

  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <ErrorIcon/>
        <h2>{t("Error")}</h2>
        <p>{t("Duplicate Email")}: {t("Your email is already associated with another applicant for the same loan application. Please provide a different email address.")}</p>
        <Button style={{padding:"6px 2rem"}} onClick={onClose} sx={{ textTransform: 'none' }}>{t("Okay")}</Button>
      </div>
    </div>
  );
};

export default EmailMatchDialog;